import React from "react";
import "./styles.css";

const AppColorInput = (props) => {
  return <input type='color' className='variant-color-inp' {...props} />;
};

export default AppColorInput;
